<template>
  <!--
    Seleção única em cards empilhados, no lugar de v-radio-group (#7286).

    Cada opção é um v-card clicável com o rádio nativo do Vuetify dentro — mantém o
    comportamento de radio (uma opção, acessível por teclado) com o visual de card.
  -->
  <v-radio-group
    :value="value"
    class="mt-0 opcao-unica-cards"
    hide-details
    @change="$emit('input', $event)"
  >
    <v-card
      v-for="opcao of opcoes"
      :key="opcao"
      outlined
      :ripple="false"
      class="mb-2 pa-3"
      :class="{ 'opcao-unica-selecionada primary--text': value === opcao }"
      @click="$emit('input', opcao)"
    >
      <v-radio :id="`${prefixoId}-${slug(opcao)}`" :ripple="false" :label="opcao" :value="opcao" />
    </v-card>
  </v-radio-group>
</template>

<script>
export default {
  name: "EOpcaoUnicaCards",
  props: {
    /** Opção marcada. */
    value: {
      type: String,
      default: null,
    },
    opcoes: {
      type: Array,
      default: () => [],
    },
    /** Prefixo do id de cada card, para automação de testes. */
    prefixoId: {
      type: String,
      required: true,
    },
  },
  methods: {
    slug(texto) {
      return String(texto)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    },
  },
};
</script>

<style scoped>
.opcao-unica-cards ::v-deep .v-input--radio-group__input {
  flex-direction: column;
  align-items: stretch;
}

/*
  v-card com :color="'primary'" preenche o fundo sólido mesmo com outlined — diferente do
  v-chip, que só tinge borda/texto. Por isso texto vem de primary--text (classe acima) e
  borda + fundo claro vêm daqui, com as variáveis que o Vuetify gera a partir do primary
  do tema (src/plugins/vuetify/themes/mainTheme.js). Não hardcodear hex: a cor do card
  selecionado para de seguir o tema se ele mudar.
*/
.opcao-unica-selecionada {
  border-color: var(--v-primary-base) !important;
  background-color: var(--v-primary-lighten5) !important;
}
</style>
